import FileInputLayout from './layout';

function FileInput({ ...props }) {
  return <FileInputLayout {...props} />;
}

export default FileInput;
